/** Re-exports the auto-generated types and defines additional content that should not get overwritten when types are generated. */

import {
  CURRENCIES,
  Currency,
  CurrencyMinorUnits,
  CurrencyNames,
  isCurrency,
} from "./iso4217/currencies";

// Re-export these for external use
export { CURRENCIES, Currency, CurrencyMinorUnits, CurrencyNames, isCurrency };

/** @returns The symbol for the given currency (ex: $ for USD) */
export function getCurrencySymbol(currency: Currency): string {
  return (0)
    .toLocaleString(undefined, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim();
}

/** @returns The narrow symbol for the given currency (ex: $ for USD) */
export function getNarrowCurrencySymbol(currency: Currency): string {
  return (0)
    .toLocaleString(undefined, {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currencyDisplay: "narrowSymbol",
    })
    .replace(/\d/g, "")
    .trim();
}
